import { HTMLAttributes } from "react";
import { FaAngleDown } from "react-icons/fa";
import { Dropdown, dropdownItems } from "@dynata/rex-raptor";

interface INavDropdownProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  items: dropdownItems;
}

export function NavDropdown({ title, items }: INavDropdownProps) {
  return (
    <div className={`nav-item`}>
      <Dropdown
        items={items}
        isNavbar={true}
      >
        <span className="nav-item-title">
          {title}
          <FaAngleDown className="nav-item-icon" />
        </span>
      </Dropdown>
    </div>
  );
}
